import React from "react";
import "../../assets/css/banner-mundial.css";
import logoMundial from "../../assets/02_Assets/World Cup-white.webp";
import groupImage from "../../assets/02_Assets/Group_21214.jpg";

interface BannerMundialComponentProps {
  multicotizadorData?: any;
}

const BannerMundialComponent: React.FC<BannerMundialComponentProps> = ({ multicotizadorData }) => {
  return (
    <section className="mundial-hero">
      <div className="mundial-hero-bg"></div>
      
      <div className="mundial-hero-container">
        <div className="mundial-hero-logo" style={{ display: 'flex', justifyContent: 'center', marginBottom: '80px', width: '100%' }}>
          <img src={logoMundial} alt="Hyundai Official Partner - FIFA World Cup 2026" style={{ maxWidth: 'min(400px, 85vw)', height: 'auto' }} />
        </div>

        <div className="mundial-hero-content-row">
          <div className="mundial-hero-left">
            <h1 className="mundial-hero-title">
            Estás a un Hyundai<br/>
            de la Copa Mundial<br/>
            de la FIFA 2026™
          </h1>
          
          <button 
            className="mundial-hero-btn"
            onClick={() => {
              const element = document.getElementById("cotizacion");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            ¡Quiero agendar el Test drive e ir al mundial!
          </button>
        </div>

        <div className="mundial-hero-right">
          <div className="mundial-img-tall">
            {/* Foto alta */}
            <img src={groupImage} alt="Mundial Hyundai" />
          </div>
          
          <div className="mundial-img-short">
            {/* Foto horizonte 1 */}
            <img src={groupImage} alt="Mundial Hyundai" />
          </div>
          
          <div className="mundial-img-short">
            {/* Foto horizonte 2 */}
            <img src={groupImage} alt="Mundial Hyundai" />
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default BannerMundialComponent;
